import { computed, inject, Injectable, type Signal } from '@angular/core';

import { Store } from '@ngrx/store';

import { TellentFeatureDiscoveryActions } from '@core/tellent-data';
import type { TellentFeatureDiscoveryFeatures } from '@core/tellent-types';

import { TellentCurrentUserDataFacade } from './tellent-current-user-data.facade';

@Injectable({ providedIn: 'root' })
export class TellentFeatureFlagsService {
  private readonly store = inject(Store);
  private readonly currentUserService = inject(TellentCurrentUserDataFacade);

  public isFeatureUsed(featureId: keyof TellentFeatureDiscoveryFeatures): Signal<boolean> {
    return computed(() => {
      const currentUser = this.currentUserService.currentUser();
      // For companies without TAC currentUser is {}
      return currentUser?.featureDiscovery?.[featureId] ?? false;
    });
  }

  public markFeatureUsed(featureId: keyof TellentFeatureDiscoveryFeatures): void {
    this.store.dispatch(TellentFeatureDiscoveryActions.update({ payload: { [featureId]: true } }));
  }
}
